export class COILandingFilterVM {
    requestId: string;
    customerPO: string;
    accountName: string;
    accountNumber: string;
    requestDate: string;
    status: any;
}
